var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWorkflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4C2 2.89543 2.89543 2 4 2H16C17.1046 2 18 2.89543 18 4V16C18 17.1046 17.1046 18 16 18H4C2.89543 18 2 17.1046 2 16V4ZM4 9.6C4 9.26863 4.26863 9 4.6 9H6.4C6.73137 9 7 9.26863 7 9.6V15.4C7 15.7314 6.73137 16 6.4 16H4.6C4.26863 16 4 15.7314 4 15.4V9.6ZM9.1 9C8.76863 9 8.5 9.26863 8.5 9.6V15.4C8.5 15.7314 8.76863 16 9.1 16H10.9C11.2314 16 11.5 15.7314 11.5 15.4V9.6C11.5 9.26863 11.2314 9 10.9 9H9.1ZM13 9.6C13 9.26863 13.2686 9 13.6 9H15.4C15.7314 9 16 9.26863 16 9.6V15.4C16 15.7314 15.7314 16 15.4 16H13.6C13.2686 16 13 15.7314 13 15.4V9.6ZM4.6 4C4.26863 4 4 4.26863 4 4.6V6.4C4 6.73137 4.26863 7 4.6 7H15.4C15.7314 7 16 6.73137 16 6.4V4.6C16 4.26863 15.7314 4 15.4 4H4.6Z",
    fill: "#6E7882"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWorkflow);
export default __webpack_public_path__ + "static/media/icon-workflow.5d622d07e76ee303a7d03044ecce3935.svg";
export { ForwardRef as ReactComponent };